import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import FichaC from '@/components/Ficha/FichaC.vue'
import NosotrosC from '@/views/QuienesSomos.vue'
import Contacto from '@/views/MsjContacto.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/ficha',
    name: 'FichaC',
    props: true,
    component: FichaC
  },
  {
    path: '/nosotros',
    name: 'NosotrosC',
    component: NosotrosC
  },
  {
    path: '/contacto',
    name: 'Contacto',
    component: Contacto
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
